// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var container = "SearchBox-module--container--OUjg8";
export var labelContainer = "SearchBox-module--labelContainer---8URM";
export var searchDescription = "SearchBox-module--searchDescription--9I0sj";
export var radioButtonContainer = "SearchBox-module--radioButtonContainer--3f0Bw";
export var radioButton = "SearchBox-module--radioButton--3EILJ";
export var checkmark = "SearchBox-module--checkmark--1MKmk";
export var radioButtonLabel = "SearchBox-module--radioButtonLabel--2WK0K";
export var searchBox = "SearchBox-module--searchBox--1YxSB";
export var borderGreen = "SearchBox-module--borderGreen--Ach-2";
export var button = "SearchBox-module--button--2kSMs";
export var buttonGreen = "SearchBox-module--buttonGreen--2wKQD";
export var hiddenLabel = "SearchBox-module--hiddenLabel--1zc43";
export var searchInput = "SearchBox-module--searchInput--1oe4e";
export var resultsBox = "SearchBox-module--resultsBox--2g6_H";
export var resultsGroup = "SearchBox-module--resultsGroup--1XEfh";
export var resultsGroupTitled = "SearchBox-module--resultsGroupTitled--2yMjU";
export var groupTitle = "SearchBox-module--groupTitle--35EPv";
export var result = "SearchBox-module--result--35mOo";
export var resultName = "SearchBox-module--resultName--1YVv3";
export var matchLocationSeparator = "SearchBox-module--matchLocationSeparator--1ye7v";
export var matchLocation = "SearchBox-module--matchLocation--gwpRk";
export var matchLocationValue = "SearchBox-module--matchLocationValue--1VrWj";
export var matchLocationType = "SearchBox-module--matchLocationType--19b-f";
export var moreResultsEllipsis = "SearchBox-module--moreResultsEllipsis--2RgnR";
export var noResultsMessage = "SearchBox-module--noResultsMessage--15jI_";
export var similarResultsContainer = "SearchBox-module--similarResultsContainer--1HUaM";
export var similarResultsTitle = "SearchBox-module--similarResultsTitle--EE_6b";
export var similarResults = "SearchBox-module--similarResults--383y_";